let ctx = null;
let voz = null;
let listo = false;

// Un solo reproductor para todas las voces: iPhone y iPad solo dejan sonar un audio que se ha activado con un toque.
export const vozTutorial = () => (voz = voz || new Audio());

// Se llama dentro del toque que abre o controla un tutorial: deja activados la voz y el sonido de clic para todos los pasos.
export function desbloquearAudio() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    ctx.resume()?.catch(() => {});
  } catch {
    // Sin Web Audio: solo falta el sonido de clic.
  }
  if (listo) return;
  listo = true;
  const a = vozTutorial();
  if (a.src) return; // ya hay una voz cargada: este mismo toque la activa al reproducirla
  a.src = "/tutoriales/silencio.mp3";
  a.play().catch(() => {});
}

// Clic suave sintetizado (sin archivo): un tono corto que baja de 1400 a 600 Hz en 70 ms.
export function sonarClic() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const t = ctx.currentTime;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.frequency.setValueAtTime(1400, t);
    o.frequency.exponentialRampToValueAtTime(600, t + 0.05);
    g.gain.setValueAtTime(0.12, t);
    g.gain.exponentialRampToValueAtTime(0.001, t + 0.07);
    o.connect(g).connect(ctx.destination);
    o.start(t);
    o.stop(t + 0.08);
  } catch {
    // Sin audio disponible: el tutorial sigue sin sonido de clic.
  }
}
